function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  width: "30",
  height: "30",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  className: styles["cls-2"] || "cls-2",
  d: "M4.28 17.238H19.72M4.28 14.264l6.395.76c.224.053 1.123.08 1.352.079s1.124-.027 1.347-.081l6.345-.759M4.28 11.29l6.387 1.519a5.847 5.847 0 002.718-.002l6.334-1.517M12 5.49v4.085"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.167 8.342l-2.168 2.168L9.83 8.342"
})));